import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

import client from "./routes/client";
import vendor from "./routes/vendor";
import admin from "./routes/admin";
import web from "./routes/web";

let routes = [...client, ...vendor, ...admin, ...web];
let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

import Auth from "./auth";

router.beforeEach((to, from, next) => {
  let dashboard = "/";
  let login = "/login";
  let user = Auth.user.get();
  let authenticated = Auth.authenticated();
  if (to.query.src && to.query.src == "crm") {
    store.dispatch("auth/setIframeSrc", {
      src: to.query.src,
      keepLogin: to.query.keeplogin,
    });
    if (to.query.keeplogin != "true") {
      return store.dispatch("auth/logout");
    }
  }

  if (to.name == "logout") {
    store.dispatch("auth/logout");
  } else {
    if (!authenticated) {
      if (to.matched.some((record) => record.meta.guest)) {
        next();
      } else {
        next(login);
      }
    } else if (authenticated && user) {
      if (to.matched.some((record) => record.meta.guest)) {
        next(dashboard);
      } else {
        if (
          user.isAdmin &&
          to.matched.some(
            (record) =>
              record.meta.admin || record.meta.vendor || record.meta.auth
          )
        ) {
          next();
        } else if (
          user.isVendor &&
          to.matched.some((record) => record.meta.vendor || record.meta.auth)
        ) {
          next();
        } else {
          if (user.isClient && to.matched.some((record) => record.meta.auth)) {
            if (to.matched.some((record) => record.meta.noClients)) {
              next(dashboard);
            } else {
              next();
            }
          } else {
            next(login);
          }
        }
      }
    } else {
      next();
    }
  }
});

export default router;
